<template>
<div class="pageContainer">
  <div class="summaryContainer">
    <div class="summary">
      <h1 class="summary-header">
        <div class="summary-symbol">{{ symbol }}
          <i class="i summary-star" 
            v-text="starClass"
            @click="toggleStar"></i>
        </div>
        <div class="summary-toolbar">
          <router-link :to="'/stock/'+$route.params.symbol+'/edit'"
            class="summary-edit">
            <i class="i">edit</i>
            Edit
          </router-link>
        </div>
      </h1>
      <div class="summary-name" v-text="stock.name"></div>
      <div class="summary-industry">{{ stock.industry }}
        <span class="summary-sector" v-if="stock.sector">
          > {{ stock.sector }}
        </span>
      </div>
    </div>

    <div class="links">
      <relevant-link title="SET"
        :url="'http://www.set.or.th/set/companyprofile.do?symbol='+symbol+'&language=th&country=TH'">
        <img src="../assets/set.png">
      </relevant-link>
      <relevant-link title="Thai VI"
        :url="'http://board.thaivi.org/jump.php?stock='+symbol+'&unread=0'">
        <img src="../assets/tvi.png">
      </relevant-link>
      <relevant-link title="Jitta"
        :url="'https://www.jitta.com/stock/bkk:'+symbol">
        <img src="../assets/jitta.png">
      </relevant-link>
      <relevant-link title="Panphol"
        :url="'http://www.panphol.com/data/page/stock_dividend/'+symbol">
        <img src="../assets/pan.png">
      </relevant-link>
      <relevant-link title="Siam Chart"
        :url="'http://siamchart.com/stock-chart/'+symbol">
        <img src="../assets/sc.png">
      </relevant-link>
      <relevant-link title="Opp Day"
        :url="'http://www.dcs-digital.com/setweb/index.php?company='+symbol+'&mai=&qt=all'">
        <img src="../assets/opp.png">
      </relevant-link>
      <relevant-link title="WSJ (Cash Flow)"
        :url="'http://quotes.wsj.com/TH/'+symbol+'/financials/annual/cash-flow'">
        <img src="../assets/wsj.png">
      </relevant-link>
      <relevant-link title="Morningstar"
        :url="'http://www.morningstar.com/stocks/XBKK/'+symbol+'/quote.html'">
        <img src="../assets/ms.png">
      </relevant-link>
      <relevant-link title="IAA Consensus"
        :url="'http://www.settrade.com/AnalystConsensus/C04_10_stock_saa_p1.jsp?txtSymbol='+symbol">
        <img src="../assets/iaa.png">
      </relevant-link>
      <relevant-link title="Bloomberg"
        :url="'https://www.bloomberg.com/quote/'+symbol+':TB'">
        <img src="../assets/bb.png">
      </relevant-link>
    </div>
  </div>

  <tabs>
    <tab name="Notes" selected>
      <div class="stock-text markdown-text" v-html="this.note"></div>
    </tab>
    <tab name="Financial">
      <div class="stock-text markdown-text" v-html="this.financial"></div>
    </tab>
    <tab name="SWOT">
      <div class="stock-label">Strengths</div>
      <ul>
        <li v-for="point in swot.s">{{ point }}</li>
      </ul>
      <div class="stock-label">Weaknesses</div>
      <ul>
        <li v-for="point in swot.w">{{ point }}</li>
      </ul>
      <div class="stock-label">Opportunities</div>
      <ul>
        <li v-for="point in swot.o">{{ point }}</li>
      </ul>
      <div class="stock-label">Threats</div>
      <ul>
        <li v-for="point in swot.t">{{ point }}</li>
      </ul>
    </tab>
  </tabs>
</div>
</template>

<script>
import Stock from '../helpers/Stock';
import marked from 'marked';

export default {
  data(){ return{
    symbol: '',

    stock: {
      swot: {}
    }
  }},

  methods: {
    initializeStock(value){
      if(value !== null){
        this.stock = value;
      }else{
        this.createEmptyStock();
      }
    },

    createEmptyStock(){
      this.stock = {
        symbol: this.symbol,
        starred: false,
        name: '',
        industry: '',
        sector: '',
        swot: {}
      };
    },

    toggleStar(){
      Stock.setStarred(this.symbol, !this.stock.starred)
      .then(() => {
        this.stock.starred = !this.stock.starred;
      });
    }
  },

  computed: {
    note(){ return marked(this.stock.note || '') },

    financial(){ return marked(this.stock.financial || '') },

    swot(){
      let res = {};
      Object.keys(this.stock.swot).forEach((key, index) => {
        res[key] = this.stock.swot[key].split('\n');
      });
      return res;
    },

    starClass(){ return this.stock.starred ? 'star' : 'star_border' }
  },

  mounted(){
    Stock.get(this.$route.params.symbol).then(snapshot => {
      this.symbol = this.$route.params.symbol;
      this.initializeStock(snapshot.val());
    });
  },

  beforeRouteUpdate(to, from, next) {
    Stock.get(to.params.symbol).then(snapshot => {
      this.symbol = to.params.symbol;
      this.initializeStock(snapshot.val());
      next();
    });
  }
}
</script>



// WEBPACK FOOTER //
// stockview.vue?a58e606e